import { useState, useContext } from "react";

import { Card, FormControl } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LanguageContext, UserContext } from "App";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import {
  createUserWithEmailAndPassword,
  getAuth,
  deleteUser,
} from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import UsersApi from "../../../Classes/API/UsersApi";
import CreateUserReq from "../../../Classes/Models/Requests/Users/CreateUserReq";
import Swal from "sweetalert2";
import CountrySelector from "layouts/authentication/sign-up/CountrySelector";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useTenant } from "../../../context/TenantContext";
import MDPhoneInput from "components/MDInput/MDPhoneInput";

import "./style.scss";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import firebaseConfig from "FirebaseConfig";
import autocomplete from "assets/theme/components/form/autocomplete";
import { UserTypesArray } from "utils/userConstants";
import UserTypeSelector from "CinicComponents/UserTypeSelector";

// Initialize Firebase
const app2 = initializeApp(firebaseConfig, "elagiCreateUser");

const CreateUser = () => {
  const navigate = useNavigate();
  const { translations } = useContext(LanguageContext);
  const CurrentUser = useContext(UserContext);
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [Address, setAddress] = useState("");
  const [Nationality, setNationality] = useState("");
  const [Number, setNumber] = useState("");
  const [Gender, setGender] = useState("");
  const [BirthdayDate, setBirthdayDate] = useState("");
  const [NationalId, setNationalId] = useState("");
  const [UserType, setUserType] = useState(null);

  const [ErrorText, setErrorText] = useState("");
  const [IsLoading, setIsLoading] = useState(false);

  const auth = getAuth(app2);
  const [user, loading, error] = useAuthState(auth);
  const { currentTenant } = useTenant();

  const tenantId = currentTenant?.id;


  const onSubmit = async () => {
    const emailPattern = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    const phonePattern = new RegExp(
      /^(?:\+?\d{1,3}[- ]?)?(\(?\d{1,4}\)?[- ]?)?(\d{1,4}[- ]?){1,3}\d{1,4}$/,
    );

    if (Name.length === 0) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserEnterName,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (UserType == null) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserUserTypeError,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }
    if (!emailPattern.test(Email)) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserValidEmail,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Password.length < 6) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserPasswordLength,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Password !== ConfirmPassword) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserPasswordMismatch,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (!phonePattern.test(Number)) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserValidPhone,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Address.length === 0) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserEnterAddress,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (!BirthdayDate) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserEnterBirthdate,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (!Gender) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserSelectGender,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (NationalId.length === 0) {
      Swal.fire({
        title: translations.CreateUserError,
        text: translations.CreateUserEnterNationalId,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    createUserWithEmailAndPassword(auth, Email, Password)
      .then(async (userCredential) => {
        const req = new CreateUserReq();
        const firebaseUser = userCredential.user;

        // Show loading toast
        setIsLoading(true);
        Swal.fire({
          title: translations.CreateUserCreatingStaff,
          html:
            '<div style="display: flex; align-items: center; justify-content: center; gap: 10px;"><div style="border: 4px solid #f3f3f3; border-top: 4px solid #3560AD; border-radius: 50%; width: 30px; height: 30px; animation: spin 1s linear infinite;"></div><span>' +
            translations.CreateUserPleaseWait +
            "</span></div>",
          icon: undefined,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        try {
          req.FirebaseId = firebaseUser.uid;
          req.Number = "+" + Number;
          req.Address = Address;
          req.Name = Name;
          req.Gender = Gender;
          req.BirthdayDate = BirthdayDate;
          req.Nationality = Nationality;
          req.UserType = UserType;
          req.isActivated = true;
          req.isSoftDeleted = false;
          req.Email = Email;
          req.NationalId = NationalId;
          req.TenantId = tenantId;

          const res = await UsersApi.CreateUser(req);

          if (res.status === "Success") {
            Swal.fire({
              title: translations.CreateUserSuccess,
              text: translations.CreateUserStaffCreatedSuccess,
              icon: "success",
              confirmButtonText: "ok",
              confirmButtonColor: "#3560AD",
            }).then(() => {
              navigate("/ManageUsers/Options", {
                state: {
                  SearchUser: res.data,
                },
              });
            });
          } else {
            await deleteUser(firebaseUser);
            Swal.fire({
              title: translations.CreateUserError,
              text: translations.CreateUserBackendError,
              icon: "error",
              confirmButtonText: "ok",
              confirmButtonColor: "#3560AD",
            });
            setErrorText(translations.CreateUserBackendError);
          }
        } catch (err) {
          console.error("Backend Error:", err);
          await deleteUser(firebaseUser);
          Swal.fire({
            title: translations.CreateUserError,
            text: translations.CreateUserUnexpectedError,
            icon: "error",
            confirmButtonText: "ok",
            confirmButtonColor: "#3560AD",
          });
          setErrorText(translations.CreateUserUnexpectedError);
        } finally {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Firebase Error:", error);
        Swal.fire({
          title: translations.CreateUserError,
          text: error.message,
          icon: "error",
          confirmButtonText: "ok",
          confirmButtonColor: "#3560AD",
        });
        setErrorText(error.message);
        setIsLoading(false);
      });
  };

  console.log(translations);
  const GenderOptions = [
    { value: "male", label: "male" },
    { value: "female", label: "female" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.CreateUserCreateStaffMember}
          </MDTypography>
          <MDButton
            onClick={() => onSubmit()}
            disabled={IsLoading}
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
              opacity: IsLoading ? 0.6 : 1,
              cursor: IsLoading ? "not-allowed" : "pointer",
            }}
            color="success"
          >
            {IsLoading
              ? translations.CreateUserCreating
              : translations.CreateUserCreateStaffMember}
          </MDButton>
        </MDBox>

        <MDBox pt={2} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            autoComplete="off"
            className={translations.setlang === "ar" ? "rtl-label" : ""}
          >
            <div className="row">
              <input
                type="text"
                name="fake-email"
                autoComplete="username"
                style={{ display: "none" }}
              />

              <input
                type="password"
                name="fake-pass-1"
                autoComplete="new-password"
                style={{ display: "none" }}
              />

              <input
                type="password"
                name="fake-pass-2"
                autoComplete="new-password"
                style={{ display: "none" }}
              />

              {/* Email - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  label="Email"
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{
                    autoComplete: "new-email",
                  }}
                />
              </div>

              {/* Password - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  label="Password"
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{
                    autoComplete: "new-password",
                  }}
                />
              </div>

              {/* Confirm Password - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type="password"
                  label="Confirm Password"
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{
                    autoComplete: "new-password",
                  }}
                />
              </div>

              {/* Name - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  label={translations.CreateUserName}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{}}
                />
              </div>

              {/* Phone Number - Mandatory */}
              <div
                className="col-md-4 mt-3"
                style={{ position: "relative", zIndex: "15" }}
              >
                <MDPhoneInput
                  value={Number}
                  onChange={(value) => setNumber(value)}
                />
              </div>

              {/* --- User Type Selector - ADDED HERE --- */}
              <div
                className="col-md-4 mt-3"
                style={{ position: "relative", zIndex: "14" }}
              >
                <UserTypeSelector
                  value={UserType ? { value: UserType, label: UserType } : null}
                  onChange={(e) => setUserType(e ? e.value : null)}
                  placeholder="Select User Type"
                />
              </div>

              {/* Address - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setAddress(e.target.value)}
                  type="text"
                  label={translations.CreateUserAddress}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Date of Birth - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setBirthdayDate(e.target.value)}
                  type="date"
                  label={translations.CreateUserAge}
                  fullWidth
                  autoComplete="off"
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: "1.07rem" },
                  }}
                />
              </div>

              {/* Gender - Mandatory */}
              <div
                className="col-md-4 mt-3"
                style={{ position: "relative", zIndex: "12" }}
              >
                <Select
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "45px",
                      minHeight: "45px",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "1.07rem",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "1.07rem",
                    }),
                  }}
                  style={{ zIndex: "9999", position: "relative" }}
                  placeholder={translations.CreateUserSelectGenderPlaceholder}
                  onChange={(e) => setGender(e.value)}
                  options={[
                    { value: "male", label: translations.CreateUsermale },
                    { value: "female", label: translations.CreateUserfemale },
                  ]}
                  fullWidth
                />
              </div>

              {/* National ID - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setNationalId(e.target.value)}
                  type="text"
                  label={translations.CreateUserNationalID}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Error Message */}
              <div className="col-md-4 mt-3">
                <MDBox mt={4} mb={1}>
                  <MDTypography
                    variant="overline"
                    color="error"
                    style={{ fontSize: "1.07rem" }}
                  >
                    {ErrorText}
                  </MDTypography>
                </MDBox>
              </div>
            </div>
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default CreateUser;
